import * as React from 'react';
import classnames from 'classnames';

import Popover from 'components/popover/Popover';

import FacebookButtonHelp from '../help/FacebookButtonHelp';

import { __t, applyTranslations } from 'utils/language';

import './facebook-button-status-message.scss';

applyTranslations(require('./facebook-button-status-message.i18n.json'));

interface Props {
  isLoggedIn: boolean,
  isCentered?: boolean
}

const MSG_KEY = 'facebook_button_status_message';

const FacebookButtonStatusMessage: React.FC<Props> = ({
  isLoggedIn,
  isCentered
}): JSX.Element => {
  const containerClasses = classnames('facebook-button-status-message', {
    'facebook-button-status-message--centered': Boolean(isCentered)
  });

  return (
    <div className={containerClasses}>
      <div className="facebook-button-status-message__status">
        {__t(`${MSG_KEY}.${isLoggedIn ? 'connected' : 'not_connected'}`)}
      </div>
      <div className="facebook-button-status-message__popover-container">
        <Popover
          classNamePopover="facebook-button-status-message__popover"
          showQuestionMark
        >
          <FacebookButtonHelp />
        </Popover>
      </div>
    </div>
  );
};

export default FacebookButtonStatusMessage;
